import * as Schema from "effect/Schema";

import { TrimmedNonEmptyString } from "./baseSchemas";

export const ProjectCheckoutDeletionMethod = Schema.Literals([
  "git-worktree",
  "trash",
  "permanent",
  "unavailable",
]);
export type ProjectCheckoutDeletionMethod = typeof ProjectCheckoutDeletionMethod.Type;

export const ProjectCheckoutDeletionPreviewInput = Schema.Struct({
  projectId: TrimmedNonEmptyString,
});
export type ProjectCheckoutDeletionPreviewInput = typeof ProjectCheckoutDeletionPreviewInput.Type;

export const ProjectCheckoutDeletionPreview = Schema.Struct({
  projectId: TrimmedNonEmptyString,
  canonicalPath: Schema.NullOr(Schema.String),
  method: ProjectCheckoutDeletionMethod,
  dirty: Schema.Boolean,
  blockers: Schema.Array(Schema.String),
  fingerprint: Schema.NullOr(Schema.String),
});
export type ProjectCheckoutDeletionPreview = typeof ProjectCheckoutDeletionPreview.Type;

export const ProjectCheckoutDeletionExecuteInput = Schema.Struct({
  projectId: TrimmedNonEmptyString,
  expectedFingerprint: TrimmedNonEmptyString,
  forceDirty: Schema.Boolean,
});
export type ProjectCheckoutDeletionExecuteInput = typeof ProjectCheckoutDeletionExecuteInput.Type;

export const ProjectCheckoutDeletionResult = Schema.Struct({
  projectId: TrimmedNonEmptyString,
  status: Schema.Literals(["deleted", "blocked"]),
  method: ProjectCheckoutDeletionMethod,
  canonicalPath: Schema.NullOr(Schema.String),
  blockers: Schema.Array(Schema.String),
});
export type ProjectCheckoutDeletionResult = typeof ProjectCheckoutDeletionResult.Type;
